/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */

function mapToParentSection(data) {
  
    return {
  
      ElectronicContactConsentAgreement: data.electronicConsentDocument === null ? null : data.electronicConsentDocument === 'true',
      ElectronicContactEmail: data.emailAddress,
  
    };
  
  }
  
   
  
  function mapToQuestionnaire() {
  
    return [];
  
  }
  
   
  
  function mapToExpenses() {
  
    return [];
  
  }
  
   
  
  export default {
  
    mapToParentSection,
  
    mapToQuestionnaire,
  
    mapToExpenses,
  
  };
  
   


// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepDeclarationDataMapper.js